<div id="imgViewer" class="openseadragon"></div>
<div id="error"></div>
<div class="error-warning"></div>
<div id="loading" class="flex-column justify-content-center align-items-center h-100">
  <div class="d-flex flex-row justify-content-centeralign-items-center">
    <img src="{{ assetsUrl }}/assets/images/game/loading.gif" />
  </div>
</div>
